<template>
  <div
    @click="$emit('selectedPanelItem', item)"
    class="panel-item alertlog-panel"
    :class="{'selected': item.selected }">
    <level-left>
      <svgicon class="level-item event-icon"
        :name="iconName" width="15" height="15" :original="true">
      </svgicon>
      <i class="level-item small fas fa-arrow-right"></i>
      <p class="block level-item ellipsis title-item">
          {{ name }}
      </p>
    </level-left>
    <level-left class="inset">
      <p class="level-item host">Host: {{ hostName }}</p>
    </level-left>
    <level-left class="inset">
        {{ item.parsed.related.processes.length }}
        <svgicon name="process_circle" width="15" height="15" :original="true">
        </svgicon>&nbsp;

        {{ item.parsed.related.binaries.length }}
        <svgicon name="binary_circle" width="15" height="15" :original="true">
        </svgicon>&nbsp;

        {{ item.parsed.related.files.length }}
        <svgicon name="file_circle" width="15" height="15" :original="true">
        </svgicon>&nbsp;

        {{ item.parsed.related.users.length }}
        <svgicon name="user" width="15" height="15" :original="true">
        </svgicon>&nbsp;

        {{ item.parsed.related.groups.length }}
        <svgicon name="group" width="15" height="15" :original="true">
        </svgicon>&nbsp;
    </level-left>
    <level-left class="inset">
      <p class="level-item date">{{ item.created | formatEpochDate(gmt) }}</p>
    </level-left>
    <!-- <div class="level">
      <span class="level-item">
        {{ item.parsed.related.processes.length }}
        <svgicon name="process" width="15" height="15" :original="true">
        </svgicon>&nbsp;&nbsp;
      </span>
      <span class="level-item">
        {{ item.parsed.related.binaries.length }}
        <svgicon name="binary" width="15" height="15" :original="true">
        </svgicon>&nbsp;&nbsp;
      </span>
      <span class="level-item">
        {{ item.parsed.related.files.length }}
        <svgicon name="file" width="15" height="15" :original="true">
        </svgicon>&nbsp;&nbsp;
      </span>
      <span class="level-item">
        {{ item.parsed.related.users.length }}
        <svgicon name="user" width="15" height="15" :original="true">
        </svgicon>&nbsp;&nbsp;
      </span>
      <span class="level-item">
        {{ item.parsed.related.groups.length }}
        <svgicon name="group" width="15" height="15" :original="true">
        </svgicon>&nbsp;&nbsp;
      </span>
    </div> -->
  </div>
</template>

<script>
import alertlog from '@/mixins/alertlog';
import gmt from '@/mixins/gmt';
import LevelLeft from '@/components/LevelLeft.vue';

export default {
  name: 'AlertLogPanelItem',
  mixins: [alertlog, gmt],
  components: {
    LevelLeft,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    name() {
      return this.getName(this.item);
    },
    hostName() {
      return this.getHostName(this.item);
    },
    iconName() {
      return this.getIconName(this.item);
    },
  },
};
</script>

<style lang="scss" scoped>

.panel-browser nav.panel .panel-item {
  padding-left: .2rem;
}

.small {
  font-size: .5rem;
}

.level-left .level-item:not(:last-child) {
  margin-right: 0;
}

.title-item {
  color: $link-color;
  margin-left: .2rem;
}

.date {
  font-size: .8rem;
  color: $expression-background;
}

.related {
  font-size: 1.1rem;
  color: $expression-background;
}

.level {
  margin-bottom: 0;
}

.inset {
  margin-left: .5rem;
}

.ellipsis {
  display:inline-block;
  width: $docs-nav-panel-width - 2.5rem;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
